<script>
	export let info
	// console.log('info:', info)
	let content = info.content
	let attributes = info.attributes
	let button_link = info.button_link
	let button_text = info.button_text
	let image = info.image
	let svg = info.svg

	let activeHighlight = attributes[3]
</script>

{#if attributes}
	<div class="main">
		<div class="inner-wrap">
			<div class="home-product-highlight-inner">
				<div class="home-product-highlight-left">
					{#if content}
						<div class="home-product-intro-content">
							{@html content}
						</div>
					{/if}
					{#if attributes}
						<div class="home-product-attributes">
							{#each attributes as item}
								<button
									class="home-product-attribute"
									class:active={item === activeHighlight}
									on:mouseenter={() => (activeHighlight = item)}>
									{@html item.attribute}
									<span class="sr-only">
										View information about
										{@html item.attribute}
										on the Brute Boot Product
									</span>
								</button>
							{/each}
						</div>
					{/if}

					{#if button_link}
						<a href={button_link} class="btn btn-black">
							+
							{@html button_text}
						</a>
					{/if}
				</div>
				<div class="home-product-highlight-right">
					<div
						class="home-product-highlight-image"
						style="background-image: url({image})">
						{#each attributes as item}
							<button
								class="home-product-image-badge"
								class:active={item === activeHighlight}
								on:mouseenter={() => (activeHighlight = item)}>
								{@html svg}
								<span class="sr-only">
									View info about the Brute Boot Product
								</span>
							</button>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
